'use strict';

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _ReplyThread = require('../elements/ReplyThread');

var _ReplyThread2 = _interopRequireDefault(_ReplyThread);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _createReactClass = require('create-react-class');

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _languageHandler = require('../../../languageHandler');

var _dispatcher = require('../../../dispatcher');

var _dispatcher2 = _interopRequireDefault(_dispatcher);

var _SettingsStore = require('../../../settings/SettingsStore');

var _SettingsStore2 = _interopRequireDefault(_SettingsStore);

var _matrixJsSdk = require('matrix-js-sdk');

var _MatrixClientPeg = require('../../../MatrixClientPeg');

var _MatrixClientPeg2 = _interopRequireDefault(_MatrixClientPeg);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
Copyright 2015, 2016 OpenMarket Ltd
Copyright 2017 New Vector Ltd
Copyright 2019 The Matrix.org Foundation C.I.C.
Copyright 2019 Michael Telatynski <7t3chguy@gmail.com>

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/

var classNames = require("classnames");

var Modal = require('../../../Modal');

var sdk = require('../../../index');
var TextForEvent = require('../../../TextForEvent');

var ObjectUtils = require('../../../ObjectUtils');

var LAST_MESSAGE_TIMESTAMP_DELAY = 5 * 60 * 1000; /* ms */
var defaultInfoMessageExclusionTypes = ['m.room.message', 'm.sticker', 'm.room.create'];

var eventTileTypes = {
    'm.room.message': 'messages.MessageEvent',
    'm.sticker': 'messages.MessageEvent',
    'm.call.invite': 'messages.TextualEvent',
    'm.call.answer': 'messages.TextualEvent',
    'm.call.hangup': 'messages.TextualEvent'
};

var stateEventTileTypes = {
    'm.room.aliases': 'messages.TextualEvent',
    // 'm.room.aliases': 'messages.RoomAliasesEvent', // too complex
    'm.room.canonical_alias': 'messages.TextualEvent',
    'm.room.member': 'messages.TextualEvent',
    'm.room.name': 'messages.TextualEvent',
    'm.room.third_party_invite': 'messages.TextualEvent',
    'm.room.history_visibility': 'messages.TextualEvent',
    'm.room.encryption': 'messages.TextualEvent',
    'm.room.topic': 'messages.TextualEvent',
    'm.room.power_levels': 'messages.TextualEvent',
    'm.room.pinned_events': 'messages.TextualEvent',
    'm.room.server_acl': 'messages.TextualEvent',
    'im.vector.modular.widgets': 'messages.TextualEvent',
    'm.room.tombstone': 'messages.TextualEvent',
    'm.room.join_rules': 'messages.TextualEvent',
    'm.room.guest_access': 'messages.TextualEvent',
    'm.room.related_groups': 'messages.TextualEvent'
};

function defaultGetHandlerTile(ev) {
    var type = ev.getType();
    return ev.isState() ? stateEventTileTypes[type] : eventTileTypes[type];
}

var getHandlerTileHandler = defaultGetHandlerTile;

function getHandlerTile(ev) {
    return getHandlerTileHandler(ev);
}

var MAX_READ_AVATARS = 5;

// Our component structure for EventTiles on the timeline is:
//
// .-EventTile------------------------------------------------.
// | MemberAvatar (SenderProfile)                   TimeStamp |
// |    .-{Message,Textual}Event---------------. Read Avatars |
// |    |   .-MFooBody-------------------.     |              |
// |    |   |  (only if MessageEvent)    |     |              |
// |    |   '----------------------------'     |              |
// |    '--------------------------------------'              |
// '----------------------------------------------------------'

module.exports = (0, _createReactClass2.default)({
    displayName: 'EventTile',

    propTypes: {
        /* the MatrixEvent to show */
        mxEvent: _propTypes2.default.object.isRequired,

        /* true if mxEvent is redacted. This is a prop because using mxEvent.isRedacted()
         * might not be enough when deciding shouldComponentUpdate - prevProps.mxEvent
         * references the same this.props.mxEvent.
         */
        isRedacted: _propTypes2.default.bool,

        /* true if this is a continuation of the previous event (which has the
         * effect of not showing another avatar/displayname
         */
        continuation: _propTypes2.default.bool,

        /* true if this is the last event in the timeline (which has the effect
         * of always showing the timestamp)
         */
        last: _propTypes2.default.bool,

        /* true if this is search context (which has the effect of greying out
         * the text
         */
        contextual: _propTypes2.default.bool,

        /* a list of words to highlight, ordered by longest first */
        highlights: _propTypes2.default.array,

        /* link URL for the highlights */
        highlightLink: _propTypes2.default.string,

        /* should show URL previews for this event */
        showUrlPreview: _propTypes2.default.bool,

        /* is this the focused event */
        isSelectedEvent: _propTypes2.default.bool,

        /* callback called when dynamic content in events are loaded */
        onHeightChanged: _propTypes2.default.func,

        /* a list of read-receipts we should show. Each object has a 'roomMember' and 'ts'. */
        readReceipts: _propTypes2.default.arrayOf(_propTypes2.default.object),

        /* opaque readreceipt info for each userId; used by ReadReceiptMarker
         * to manage its animations. Should be an empty object when the room
         * first loads
         */
        readReceiptMap: _propTypes2.default.object,

        /* A function which is used to check if the parent panel is being
         * unmounted, to avoid unnecessary work. Should return true if we
         * are being unmounted.
         */
        checkUnmounting: _propTypes2.default.func,

        /* the status of this event - ie, mxEvent.status. Denormalised to here so
         * that we can tell when it changes. */
        eventSendStatus: _propTypes2.default.string,

        /* the shape of the tile. by default, the layout is intended for the
         * normal room timeline.  alternative values are: "file_list", "file_grid"
         * and "notif".  This could be done by CSS, but it'd be horribly inefficient.
         * It could also be done by subclassing EventTile, but that'd be quite
         * boiilerplatey.  So just make the necessary render decisions conditional
         * for now.
         */
        tileShape: _propTypes2.default.string,

        // show twelve hour timestamps
        isTwelveHour: _propTypes2.default.bool,

        // helper function to access relations for this event
        getRelationsForEvent: _propTypes2.default.func,

        // whether to show reactions for this event
        showReactions: _propTypes2.default.bool
    },

    getDefaultProps: function getDefaultProps() {
        return {
            // no-op function because onHeightChanged is optional yet some sub-components assume its existence
            onHeightChanged: function onHeightChanged() {}
        };
    },

    getInitialState: function getInitialState() {
        return {
            // Whether the action bar is focused.
            actionBarFocused: false,
            // Whether the event's sender has been verified.
            verified: null,
            // Whether onRequestKeysClick has been called since mounting.
            previouslyRequestedKeys: false,
            // The Relations model from the JS SDK for reactions to `mxEvent`
            reactions: this.getReactions()
        };
    },

    contextTypes: {
        matrixClient: _propTypes2.default.instanceOf(_matrixJsSdk.MatrixClient).isRequired
    },

    componentWillMount: function componentWillMount() {
        // don't do RR animations until we are mounted
        this._suppressReadReceiptAnimation = true;
        this._verifyEvent(this.props.mxEvent);
    },

    componentDidMount: function componentDidMount() {
        this._suppressReadReceiptAnimation = false;
        var client = this.context.matrixClient;
        client.on("deviceVerificationChanged", this.onDeviceVerificationChanged);
        this.props.mxEvent.on("Event.decrypted", this._onDecrypted);
        if (this.props.showReactions) {
            this.props.mxEvent.on("Event.relationsCreated", this._onReactionsCreated);
        }
    },

    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
        // re-check the sender verification as outgoing events progress through
        // the send process.
        if (nextProps.eventSendStatus !== this.props.eventSendStatus) {
            this._verifyEvent(nextProps.mxEvent);
        }
    },

    shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
        if (!ObjectUtils.shallowEqual(this.state, nextState)) {
            return true;
        }

        return !this._propsEqual(this.props, nextProps);
    },

    componentWillUnmount: function componentWillUnmount() {
        var client = this.context.matrixClient;
        client.removeListener("deviceVerificationChanged", this.onDeviceVerificationChanged);
        this.props.mxEvent.removeListener("Event.decrypted", this._onDecrypted);
        if (this.props.showReactions) {
            this.props.mxEvent.removeListener("Event.relationsCreated", this._onReactionsCreated);
        }
    },

    /** called when the event is decrypted after we show it.
     */
    _onDecrypted: function _onDecrypted() {
        // we need to re-verify the sending device.
        // (we call onHeightChanged in _verifyEvent to handle the case where decryption
        // has caused a change in size of the event tile)
        this._verifyEvent(this.props.mxEvent);
        this.forceUpdate();
    },

    onDeviceVerificationChanged: function onDeviceVerificationChanged(userId, device) {
        if (userId === this.props.mxEvent.getSender()) {
            this._verifyEvent(this.props.mxEvent);
        }
    },

    _verifyEvent: async function _verifyEvent(mxEvent) {
        var _this = this;

        if (!mxEvent.isEncrypted()) {
            return;
        }

        var verified = await this.context.matrixClient.isEventSenderVerified(mxEvent);
        this.setState({
            verified: verified
        }, function () {
            // Decryption may have caused a change in size
            _this.props.onHeightChanged();
        });
    },

    _propsEqual: function _propsEqual(objA, objB) {
        var keysA = (0, _keys2.default)(objA);
        var keysB = (0, _keys2.default)(objB);

        if (keysA.length !== keysB.length) {
            return false;
        }

        for (var i = 0; i < keysA.length; i++) {
            var key = keysA[i];

            if (!objB.hasOwnProperty(key)) {
                return false;
            }

            // need to deep-compare readReceipts
            if (key === 'readReceipts') {
                var rA = objA[key];
                var rB = objB[key];
                if (rA === rB) {
                    continue;
                }

                if (!rA || !rB) {
                    return false;
                }

                if (rA.length !== rB.length) {
                    return false;
                }
                for (var j = 0; j < rA.length; j++) {
                    if (rA[j].userId !== rB[j].userId) {
                        return false;
                    }
                    // one has a member set and the other doesn't?
                    if (rA[j].roomMember !== rB[j].roomMember) {
                        return false;
                    }
                }
            } else {
                if (objA[key] !== objB[key]) {
                    return false;
                }
            }
        }
        return true;
    },

    shouldHighlight: function shouldHighlight() {
        var actions = this.context.matrixClient.getPushActionsForEvent(this.props.mxEvent);
        if (!actions || !actions.tweaks) {
            return false;
        }

        // don't show self-highlights from another of our clients
        if (this.props.mxEvent.getSender() === this.context.matrixClient.credentials.userId) {
            return false;
        }

        return actions.tweaks.highlight;
    },

    onSenderProfileClick: function onSenderProfileClick(event) {
        var mxEvent = this.props.mxEvent;
        _dispatcher2.default.dispatch({
            action: 'insert_mention',
            user_id: mxEvent.getSender()
        });
    },

    onCryptoClick: function onCryptoClick(e) {
        console.log("Crypto disabled");
    },

    onRequestKeysClick: function onRequestKeysClick() {
        this.setState({
            // Indicate in the UI that the keys have been requested (this is expected to
            // be reset if the component is mounted in the future).
            previouslyRequestedKeys: true
        });

        // Cancel any outgoing key request for this event and resend it. If a response
        // is received for the request with the required keys, the event could be
        // decrypted successfully.
        this.context.matrixClient.cancelAndResendEventRoomKeyRequest(this.props.mxEvent);
    },

    onPermalinkClicked: function onPermalinkClicked(e) {
        // This allows the permalink to be opened in a new tab/window or copied as
        // matrix.to, but also for it to enable routing within Riot when clicked.
        e.preventDefault();
        _dispatcher2.default.dispatch({
            action: 'view_room',
            event_id: this.props.mxEvent.getId(),
            highlighted: true,
            room_id: this.props.mxEvent.getRoomId()
        });
    },

    onActionBarFocusChange: function onActionBarFocusChange(focused) {
        this.setState({
            actionBarFocused: focused
        });
    },
    getTile: function getTile() {
        return this.refs.tile;
    },
    getReplyThread: function getReplyThread() {
        return this.refs.replyThread;
    },
    getReactions: function getReactions() {
        if (!this.props.showReactions || !this.props.getRelationsForEvent) {
            return null;
        }
        var eventId = this.props.mxEvent.getId();
        if (!eventId) {
            // XXX: Temporary diagnostic logging for https://github.com/vector-im/riot-web/issues/11120
            console.error("EventTile attempted to get relations for an event without an ID");
            // Use event's special `toJSON` method to log key data.
            console.log((0, _stringify2.default)(this.props.mxEvent, null, 4));
        }
        return this.props.getRelationsForEvent(eventId, "m.annotation", "m.reaction");
    },
    _onReactionsCreated: function _onReactionsCreated(relationType, eventType) {
        if (relationType !== "m.annotation" || eventType !== "m.reaction") {
            return;
        }
        this.props.mxEvent.removeListener("Event.relationsCreated", this._onReactionsCreated);
        this.setState({
            reactions: this.getReactions()
        });
    },
    _getUserType: function _getUserType(userId) {
        if (!userId) return 'unknown';
        if (userId.includes("_e:")) return "enduser";
        if (userId.includes("_a:")) return "agentuser";
        if (userId.includes("_s:")) return "superuser";
        return "adminuser";
    },


    render: function render() {
        var _classNames,
            _this2 = this;

        var _props = this.props,
            mxEvent = _props.mxEvent,
            eventSender = _props.mxEvent.sender;

        var senderId = mxEvent.getSender();

        var infoMessageExclusionTypes = this.props.infoMessageExclusionTypes || defaultInfoMessageExclusionTypes;
        var showSenderAvatar = this.props.showSenderAvatar === true;
        var avatarPosition = this.props.avatarPosition || 'content';
        var messageOverlayPosition = this.props.messageOverlayPosition || 'wrapper';

        var MessageTimestamp = sdk.getComponent('messages.MessageTimestamp');
        var SenderProfile = sdk.getComponent('messages.SenderProfile');
        var MemberAvatar = sdk.getComponent('avatars.MemberAvatar');

        //console.info("EventTile showUrlPreview for %s is %s", this.props.mxEvent.getId(), this.props.showUrlPreview);

        var content = mxEvent.getContent();
        var msgtype = content.msgtype;
        // Access the msg type directly as the getContent will return the replaced
        // event type and not the original event type
        var isShadow = mxEvent.event.content.msgtype === 'g.shadow';
        var eventType = mxEvent.getType();

        // Info messages are basically information about commands processed on a room
        var isBubbleMessage = eventType.startsWith("m.key.verification") || eventType === "m.room.message" && msgtype && msgtype.startsWith("m.key.verification");
        var isInfoMessage = !isBubbleMessage && !infoMessageExclusionTypes.includes(eventType);

        var tileHandler = getHandlerTile(mxEvent);
        // If we're showing hidden events in the timeline, we should use the
        // source tile when there's no regular tile for an event and also for
        // replace relations (which otherwise would display as a confusing
        // duplicate of the thing they are replacing).
        var useSource = !tileHandler || mxEvent.isRelation("m.replace");
        if (useSource && _SettingsStore2.default.getValue("showHiddenEventsInTimeline")) {
            // Reuse info message avatar and sender profile styling
            isInfoMessage = true;
        }
        if (!tileHandler) {
            return null;
        }
        var EventTileType = sdk.getComponent(tileHandler);

        var isSender = this.props.tileShape !== 'file_grid' && senderId === this.context.matrixClient.credentials.userId;
        var avatar = void 0;
        var sender = void 0;
        var avatarSize = void 0;
        var needsSenderProfile = void 0;

        if (this.props.tileShape === "notif") {
            avatarSize = 24;
            needsSenderProfile = true;
        } else if (isInfoMessage) {
            // a small avatar, with no sender profile, for
            // joins/parts/etc
            avatarSize = 14;
            needsSenderProfile = false;
        } else if (this.props.continuation && this.props.tileShape !== "file_grid") {
            // no avatar or sender profile for continuation messages
            avatarSize = 0;
            needsSenderProfile = false;
        } else {
            avatarSize = 32;
            needsSenderProfile = true;
        }

        if (eventSender && avatarSize && (!isSender || showSenderAvatar)) {
            avatar = _react2.default.createElement(
                'div',
                { className: 'mx_EventTile_avatar' },
                _react2.default.createElement(MemberAvatar, {
                    member: eventSender,
                    width: avatarSize, height: avatarSize,
                    viewUserOnClick: true,
                    mxEvent: mxEvent
                })
            );
        }

        var isSending = ['sending', 'queued', 'encrypting'].indexOf(this.props.eventSendStatus) !== -1;
        var isRedacted = isMessageEvent(mxEvent) && this.props.isRedacted;
        var isEncryptionFailure = mxEvent.isDecryptionFailure();
        var userType = this._getUserType(senderId);
        var isLast = this.props.last;
        var hasReactions = this.state.reactions && this.state.reactions.getSortedAnnotationsByKey().some(function (_ref) {
            var _ref2 = (0, _slicedToArray3.default)(_ref, 2),
                _ = _ref2[0],
                events = _ref2[1];

            return events.size > 0;
        });
        var classes = classNames((_classNames = {
            mx_EventTile_bubbleContainer: isBubbleMessage,
            mx_EventTile: true,
            mx_EventTile_info: isInfoMessage,
            mx_EventTile_12hr: this.props.isTwelveHour,
            mx_EventTile_encrypting: this.props.eventSendStatus === 'encrypting',
            mx_EventTile_sending: isSending,
            mx_EventTile_notSent: this.props.eventSendStatus === 'not_sent',
            mx_EventTile_highlight: this.props.tileShape === 'notif' ? false : this.shouldHighlight(),
            mx_EventTile_selected: this.props.isSelectedEvent,
            mx_EventTile_continuation: this.props.tileShape ? '' : this.props.continuation,
            mx_EventTile_last: isLast,
            mx_EventTile_contextual: this.props.contextual,
            mx_EventTile_actionBarFocused: this.state.actionBarFocused,
            mx_EventTile_verified: !isBubbleMessage && this.state.verified === true,
            mx_EventTile_unverified: !isBubbleMessage && this.state.verified === false,
            mx_EventTile_bad: isEncryptionFailure,
            mx_EventTile_emote: msgtype === 'm.emote',
            mx_EventTile_shadow: isShadow,
            mx_EventTile_redacted: isRedacted,
            mx_EventTile_sender: isSender
        }, (0, _defineProperty3.default)(_classNames, 'mx_EventTile_' + userType, true), (0, _defineProperty3.default)(_classNames, 'mx_EventTile_image', msgtype === 'm.image'), (0, _defineProperty3.default)(_classNames, 'mx_EventTile_' + eventType.replace(/\./g, '_'), true), (0, _defineProperty3.default)(_classNames, 'mx_EventTile_' + tileHandler.replace(/\./g, '_'), true), (0, _defineProperty3.default)(_classNames, 'mx_EventTile_reactions', hasReactions), (0, _defineProperty3.default)(_classNames, 'mx_EventTile_memberAvatar', avatarSize > 0), _classNames));

        var permalink = "#";
        if (this.props.permalinkCreator) {
            permalink = this.props.permalinkCreator.forEvent(mxEvent.getId());
        }

        if (needsSenderProfile) {
            var text = null;
            if (!this.props.tileShape || this.props.tileShape === 'reply' || this.props.tileShape === 'reply_preview') {
                if (msgtype === 'm.image') text = (0, _languageHandler._td)('%(senderName)s sent an image');else if (msgtype === 'm.video') text = (0, _languageHandler._td)('%(senderName)s sent a video');else if (msgtype === 'm.file') text = (0, _languageHandler._td)('%(senderName)s uploaded a file');
                sender = _react2.default.createElement(SenderProfile, { onClick: this.onSenderProfileClick, mxEvent: mxEvent, text: text });
            } else {
                sender = _react2.default.createElement(SenderProfile, { mxEvent: mxEvent });
            }
        }

        var timestamp = mxEvent.getTs() ? _react2.default.createElement(MessageTimestamp, { showTwelveHour: this.props.isTwelveHour, ts: mxEvent.getTs() }) : null;

        var keyRequestHelpText = _react2.default.createElement(
            'div',
            { className: 'mx_EventTile_keyRequestInfo_tooltip_contents' },
            _react2.default.createElement(
                'p',
                null,
                this.state.previouslyRequestedKeys ? (0, _languageHandler._t)('Your key share request has been sent - please check your other devices ' + 'for key share requests.') : (0, _languageHandler._t)('Key share requests are sent to your other devices automatically. If you ' + 'rejected or dismissed the key share request on your other devices, click ' + 'here to request the keys for this session again.')
            ),
            _react2.default.createElement(
                'p',
                null,
                (0, _languageHandler._t)('If your other devices do not have the key for this message you will not ' + 'be able to decrypt them.')
            )
        );
        var keyRequestInfoContent = this.state.previouslyRequestedKeys ? (0, _languageHandler._t)('Key request sent.') : (0, _languageHandler._t)('<requestLink>Re-request encryption keys</requestLink> from your other devices.', {}, { 'requestLink': function requestLink(sub) {
                return _react2.default.createElement(
                    'a',
                    { onClick: _this2.onRequestKeysClick },
                    sub
                );
            } });

        var keyRequestInfo = null;

        var reactionsRow = void 0;
        if (!isRedacted) {
            var ReactionsRow = sdk.getComponent('messages.ReactionsRow');
            reactionsRow = _react2.default.createElement(ReactionsRow, {
                mxEvent: mxEvent,
                reactions: this.state.reactions
            });
        }

        var MessageOverlay = sdk.getComponent('messages.MessageOverlay');
        var messageOverlay = messageOverlayPosition === 'wrapper' ? _react2.default.createElement(MessageOverlay, {
            mxEvent: mxEvent,
            reactions: this.state.reactions,
            permalinkCreator: this.props.permalinkCreator,
            isLast: isLast
        }) : undefined;

        switch (this.props.tileShape) {
            case 'notif':
                {
                    var room = this.context.matrixClient.getRoom(mxEvent.getRoomId());
                    return _react2.default.createElement(
                        'div',
                        { className: classes },
                        _react2.default.createElement(
                            'div',
                            { className: 'mx_EventTile_roomName' },
                            _react2.default.createElement(
                                'a',
                                { href: permalink, onClick: this.onPermalinkClicked },
                                room ? room.name : ''
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'mx_EventTile_senderDetails' },
                            avatar,
                            _react2.default.createElement(
                                'a',
                                { href: permalink, onClick: this.onPermalinkClicked },
                                sender,
                                timestamp
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'mx_EventTile_line' },
                            _react2.default.createElement(EventTileType, { ref: 'tile',
                                mxEvent: mxEvent,
                                highlights: this.props.highlights,
                                highlightLink: this.props.highlightLink,
                                showUrlPreview: this.props.showUrlPreview,
                                onHeightChanged: this.props.onHeightChanged,
                                permalinkCreator: this.props.permalinkCreator })
                        )
                    );
                }
            case 'file_grid':
                {
                    return _react2.default.createElement(
                        'div',
                        { className: classes },
                        _react2.default.createElement(
                            'div',
                            { className: 'mx_EventTile_line' },
                            _react2.default.createElement(EventTileType, { ref: 'tile',
                                mxEvent: mxEvent,
                                highlights: this.props.highlights,
                                highlightLink: this.props.highlightLink,
                                showUrlPreview: this.props.showUrlPreview,
                                tileShape: this.props.tileShape,
                                onHeightChanged: this.props.onHeightChanged,
                                permalinkCreator: this.props.permalinkCreator })
                        )
                    );
                }

            case 'reply':
            case 'reply_preview':
                {
                    var thread = void 0;
                    if (this.props.tileShape === 'reply_preview') {
                        thread = _ReplyThread2.default.makeThread(this.props.mxEvent, this.props.onHeightChanged, this.props.permalinkCreator, 'replyThread');
                    }
                    return _react2.default.createElement(
                        'div',
                        { className: classes },
                        sender,
                        _react2.default.createElement(
                            'div',
                            { className: 'mx_EventTile_reply' },
                            _react2.default.createElement(
                                'div',
                                { className: 'mx_EventTile_content_wrapper' },
                                _react2.default.createElement(EventTileType, { ref: 'tile',
                                    mxEvent: this.props.mxEvent,
                                    highlights: this.props.highlights,
                                    highlightLink: this.props.highlightLink,
                                    onHeightChanged: this.props.onHeightChanged,
                                    showUrlPreview: false,
                                    replyThread: thread,
                                    permalinkCreator: this.props.permalinkCreator })
                            )
                        )
                    );
                }
            default:
                {
                    var _thread = _ReplyThread2.default.makeThread(this.props.mxEvent, this.props.onHeightChanged, this.props.permalinkCreator, 'replyThread');
                    // tab-index=-1 to allow it to be focusable but do not add tab stop for it, primarily for screen readers
                    return _react2.default.createElement(
                        'div',
                        { className: classes, tabIndex: -1 },
                        sender,
                        _react2.default.createElement(
                            'div',
                            { className: 'mx_EventTile_line' },
                            _react2.default.createElement(
                                'div',
                                { className: 'mx_EventTile_content_wrapper' },
                                _thread,
                                _react2.default.createElement(
                                    'div',
                                    { className: 'mx_EventTile_content_container' },
                                    _react2.default.createElement(EventTileType, { ref: 'tile',
                                        mxEvent: this.props.mxEvent,
                                        replacingEventId: this.props.replacingEventId,
                                        highlights: this.props.highlights,
                                        highlightLink: this.props.highlightLink,
                                        showUrlPreview: this.props.showUrlPreview,
                                        onHeightChanged: this.props.onHeightChanged,
                                        messageOverlayPosition: messageOverlayPosition,
                                        reactions: this.state.reactions,
                                        permalinkCreator: this.props.permalinkCreator }),
                                    avatarPosition === 'content' && avatar
                                ),
                                avatarPosition === 'wrapper' && avatar,
                                isLast && hasReactions && reactionsRow,
                                messageOverlay
                            ),
                            !isLast && hasReactions && reactionsRow,
                            keyRequestInfo
                        )
                    );
                }
        }
    }
});

module.exports.setTileHandler = function (handler) {
    getHandlerTileHandler = handler;
};

// XXX this'll eventually be dynamic based on the fields once we have extensible event types
var messageTypes = ['m.room.message', 'm.sticker'];
function isMessageEvent(ev) {
    return messageTypes.includes(ev.getType());
}

module.exports.haveTileForEvent = function (e) {
    // Only messages have a tile (black-rectangle) if redacted
    if (e.isRedacted() && !isMessageEvent(e)) return false;

    // No tile for replacement events since they update the original tile
    if (e.isRelation("m.replace")) return false;

    var handler = getHandlerTile(e);
    if (handler === undefined) return false;
    if (handler === 'messages.TextualEvent') {
        return TextForEvent.textForEvent(e) !== '';
    } else if (handler === 'messages.RoomCreate') {
        return Boolean(e.getContent()['predecessor']);
    } else {
        return true;
    }
};

module.exports.getHandlerTile = getHandlerTile;
//# sourceMappingURL=EventTile.js.map